import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";

const ReferenceTypeList = () => {
  const navigate = useNavigate();

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "VCTS Name",
      accessorKey: "vcts_name",
      cell: NACell,
    },
  ];
  return (
    <DataTable
      url={APIS.REFERENCE_TYPE}
      queryKey={"reference-type"}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      tableName={"reference-type"}
    />
  );
};

export default ReferenceTypeList;
